<h2 mat-dialog-title i18n>Delete item?</h2>
<mat-dialog-content i18n>This will delete item from the list and can not be undone.</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close i18n>Cancel</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button color="warn" [mat-dialog-close]="true" i18n="button label">Delete</button>
</mat-dialog-actions>